import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import EmbeddableEditor from './pages/HtmlEditorTestPage/components/EmbeddableEditor/EmbeddableEditor';
import TestPage from './pages/HtmlEditorTestPage/TestPage';
import HomePage from './pages/HomePage/HomePage';
import DataSourcesPage from './pages/DataSourcesPage/DataSourcesPage';
import ApplicationsPage from './pages/ApplicationsPage/ApplicationsPage';
import { FederateProvider } from './shared/contexts/FederateContext';
import { RegionProvider } from './shared/contexts/RegionContext';
import './global.scss';

function FederateRoutesLayout() {
  return (
    <FederateProvider>
      <Outlet />
    </FederateProvider>
  );
}

function App() {
  return (
    <RegionProvider>
      <Router>
        <Routes>
          {/* Routes that require federate authentication */}
          <Route element={<FederateRoutesLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/collections" element={<DataSourcesPage />} />
            <Route path="/applications" element={<ApplicationsPage />} />
          </Route>

          {/* Routes that don't require federate authentication */}
          <Route path="/html-editor" element={<EmbeddableEditor />} />
          <Route path="/html-editor/test" element={<TestPage />} />
          <Route path="/artifacts/:artifactId" element={<EmbeddableEditor />} />
        </Routes>
      </Router>
    </RegionProvider>
  );
}

export default App;
